@if (form) {
  <div class="layout--column">
    <form [formGroup]="form">
      <div class="layout__inner-card">
        @if (hasTitle) {
          <h4 i18n>Rapport #{{ index + 1 }}</h4>
        }
        <div class="layout--gap mb-4">
          <div class="layout--full-width">
            <label class="label-top" i18n>Numéro de police</label>
            <input [formControl]="form.controls.policyNumber" pInputText />
          </div>
          <div class="layout--full-width">
            <label class="label-top" i18n>Nom complet</label>
            <input [formControl]="form.controls.fullName" type="text" pInputText />
          </div>
          <div class="layout--full-width">
            <label class="label-top" i18n>Agent</label>
            <input [formControl]="form.controls.agent" type="text" pInputText />
          </div>
        </div>
        <div class="layout--gap mb-4">
          <div class="layout--full-width">
            <label class="label-top" i18n>Assureur</label>
            <p-dropdown
              [options]="insurerOptions | emTranslate"
              [formControl]="form.controls.insurer"
              optionLabel="name"
              optionValue="value"></p-dropdown>
          </div>
          <div class="layout--full-width">
            <label class="label-top" i18n>Status</label>
            <p-dropdown
              [options]="statusOptions | emTranslate"
              [formControl]="form.controls.status"
              optionLabel="name"
              optionValue="value"></p-dropdown>
          </div>
          <div class="layout--full-width">
            <label class="label-top" i18n>Type</label>
            <p-dropdown
              [options]="typeOptions | emTranslate"
              [formControl]="form.controls.type"
              optionLabel="name"
              optionValue="value"></p-dropdown>
          </div>
        </div>
        <div class="layout--gap flex-column gap-0">
          @for (insurance of form.controls.insurances.controls; track insurance; let i = $index) {
            <form>
              <div class="layout__inner-card m-0 pr-0">
                <p-divider i18n
                  ><strong>Assurance {{ insurance.controls.duration.value }}</strong></p-divider
                >
                <div class="layout--gap">
                  <div class="layout--full-width">
                    <label class="label-top" i18n>Prime annuelle</label>
                    <input
                      [thousandSeparator]="isFr ? ' ' : ','"
                      [prefix]="insurance.controls.annualPremium.value && !isFr ? '$' : ''"
                      [suffix]="isFr ? ' $' : ''"
                      mask="separator.0"
                      [formControl]="insurance.controls.annualPremium"
                      pInputText />
                  </div>
                  <div class="layout--full-width">
                    <label class="label-top" i18n>Couverture</label>
                    <input
                      [thousandSeparator]="isFr ? ' ' : ','"
                      [prefix]="insurance.controls.coverage.value && !isFr ? '$' : ''"
                      [suffix]="isFr ? ' $' : ''"
                      mask="separator.0"
                      [formControl]="insurance.controls.coverage"
                      pInputText />
                  </div>
                  <div class="layout--full-width">
                    <label class="label-top" i18n>Produit</label>
                    <input [formControl]="insurance.controls.duration" type="text" pInputText />
                  </div>
                  <div class="layout--full-width">
                    <label class="label-top" i18n>Type d’assurance</label>
                    <p-dropdown
                      [options]="insuranceTypeOptions | emTranslate"
                      [formControl]="insurance.controls.insuranceType"
                      optionLabel="name"
                      optionValue="value"></p-dropdown>
                  </div>
                </div>
              </div>
            </form>
          }
        </div>
        @if (form.controls.proposalLink.value) {
          <button
            pButton
            type="button"
            i18n-label
            label="Proposition"
            icon="pi pi-eye"
            class="p-button-text p-button-plain"
            (click)="openProposal()"></button>
        }
        @if (!!form.controls.canDownloadContract.value) {
          <button
            pButton
            type="button"
            i18n-label
            label="Contrat"
            icon="pi pi-download"
            class="p-button-text p-button-plain"
            (click)="getContract()"></button>
        }
        <button
          pButton
          type="button"
          i18n-label
          label="ABF"
          icon="pi pi-download"
          class="p-button-text p-button-plain"
          (click)="getFna()"></button>
        @if (!!form.controls.hasReplacementNotice.value) {
          <button
            pButton
            type="button"
            i18n-label
            label="Remplacement de police"
            icon="pi pi-download"
            class="p-button-text p-button-plain"
            (click)="getReplacementNotice()"></button>
        }
        <button
          [loading]="isClientAccessLinkButtonLoading"
          pButton
          type="button"
          i18n-label
          label="Envoyer lien d'accès client"
          icon="pi pi-send"
          class="p-button-text p-button-plain"
          (click)="sendClientSessionAccessLink()"></button>
        @if (secretCode) {
          <button
            pButton
            type="button"
            i18n-label
            label="Code Secret"
            icon="pi pi-exclamation-triangle"
            class="p-button-text p-button-plain"
            [pTooltip]="secretCode"
            tooltipStyleClass="custom-tooltip custom-tooltip-bold"
            tooltipPosition="bottom"></button>
        }
      </div>
    </form>
  </div>
}
